export interface HistoryEntry {
  ts: number;
  input: unknown;
  status: number;
  latency_ms: number;
  response: unknown;
  headers?: Record<string, string>;
  warnings?: Array<Record<string, unknown>>;
  revision_used?: { revision_no: number; revision_id: string } | null;
  threshold_used?: number | null;
  error?: string;
  // TODO(Phase 2b): remove — use revision_used.revision_no instead.
  revision_no?: number;
}

const MAX = 20;

function key(projectId: string, modelId: string): string {
  return `autolab:history:${projectId}:${modelId}`;
}

export function loadHistory(projectId: string, modelId: string): HistoryEntry[] {
  try {
    const raw = localStorage.getItem(key(projectId, modelId));
    return raw ? (JSON.parse(raw) as HistoryEntry[]) : [];
  } catch {
    return [];
  }
}

export function pushHistory(
  projectId: string,
  modelId: string,
  entry: Omit<HistoryEntry, "ts">,
): void {
  const list = loadHistory(projectId, modelId);
  const next = [{ ...entry, ts: Date.now() }, ...list].slice(0, MAX);
  localStorage.setItem(key(projectId, modelId), JSON.stringify(next));
}

export function clearHistory(projectId: string, modelId: string): void {
  localStorage.removeItem(key(projectId, modelId));
}
